module.exports = {"230704001":"友好街道","230704003":"双子河街道","230704004":"铁林街道","230704400":"三合经营所","230704401":"松园林场","230704402":"中心经营所","230704403":"永青经营所","230704404":"碧云经营所","230704405":"友谊经营所","230704406":"青杨经营所","230704407":"岭峰林场","230704408":"奋斗林场","230704409":"东卡林场","230704410":"鸡爪河林场","230704411":"绿源林场","230704412":"广川经营所","230704413":"朝阳经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230704.json
// module id = 685
// module chunks = 0